var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeverageGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72495 22.9967C8.42952 22.8005 8.39653 22.6858 8.51068 22.3413C9.39132 19.7277 10.2719 17.1087 11.1581 14.4951C11.1852 14.4185 11.207 14.3365 11.2396 14.2381C11.1412 14.2383 11.0756 14.2384 11.0046 14.2385C9.80787 14.2406 8.61115 14.2427 7.41444 14.2449C6.98821 14.2456 6.82929 13.9945 7.0144 13.6062C8.63678 10.1826 10.2592 6.75896 11.8761 3.33534C11.985 3.10017 12.1542 3.00151 12.411 3.00106C14.0777 3.00359 15.7443 2.99518 17.411 2.99771C17.881 2.99688 18.0564 3.30258 17.8167 3.71284C16.6126 5.78054 15.4086 7.84824 14.2101 9.91593C14.172 9.98157 14.1338 10.0472 14.0793 10.1457C14.1723 10.151 14.2433 10.1563 14.3089 10.1562C15.4619 10.1542 16.6149 10.1521 17.7624 10.1501C17.828 10.15 17.8936 10.1444 17.9592 10.1552C18.3527 10.2092 18.5063 10.5696 18.2719 10.8869C17.8031 11.5107 17.3342 12.1345 16.8599 12.7583C14.3521 16.0742 11.8498 19.3955 9.34192 22.706C9.24924 22.8263 9.10185 22.9086 8.97634 23.0071C8.87796 22.9964 8.80145 22.9965 8.72495 22.9967Z",
    fill: "#59A310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeverageGreen);
export default __webpack_public_path__ + "static/media/leverage-green.1bf61c090dc902fa5a25532e38fa4176.svg";
export { ForwardRef as ReactComponent };